/* ==========================================================================
   UiPanelAccommodationPackages > Config
   ========================================================================== */

/* Configuration */
const configuration = {
    uiPanel: {
        selector: '[data-component="UiPanel"][data-type="ui-panel-accommodation-packages"]',
        type: 'ui-panel-accommodation-packages'
    },
    panelAccommodation: {
        selector:
            '[data-component="UiPanel"][data-type="ui-panel-accommodation-packages"] ' +
            '[data-component="PanelAccommodationPackages"]'
    },
    actionAddRoom: {
        type: 'addRoom',
        selector: '[data-component="UiPanel"][data-type="ui-panel-accommodation-packages"] [data-type="addRoom"]'
    }
};

const config = () => configuration;

module.exports = config;
